import { render, staticRenderFns } from "./Build.vue?vue&type=template&id=57224350"
import script from "./Build.vue?vue&type=script&lang=js"
export * from "./Build.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports